// extracted by mini-css-extract-plugin
module.exports = {"firstControlUnit":"_2c-veLPJfZvbxmoW5EJNR5","secondControlUnit":"B6sZ7LI2eiVEVSNblJ_E_"};